<template>
	<span class="mini-pager"
		><sym-icon name="caret-left-14-bold" :class="disableLeft ? 'mini-pager-disabled' : null" @click.prevent.stop="goPrev"></sym-icon
		><sym-icon name="caret-right-14-bold" :class="disableRight ? 'mini-pager-disabled' : null" @click.prevent.stop="goNext"></sym-icon
	></span>
</template>

<script setup lang="ts">
import SymIcon from "./SymIcon.vue";

const props = defineProps({
  disableLeft: Boolean,
  disableRight: Boolean
});
const emit = defineEmits(["left", "right"]);
function goPrev() {
  emit("left");
}
function goNext() {
  emit("right");
}
</script>

<style>
.mini-pager {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: stretch;
	min-width: 64px;
	min-height: 32px;
	line-height: 32px;
}
.mini-pager > .fi {
	min-width: 32px;
	color: var(--active);
	cursor: pointer;
}
.mini-pager > .fi.mini-pager-disabled {
	color: var(--inactive);
	cursor: not-allowed;
}
</style>
